/**
 * Couleurs des tuiles de la météo
 */
export const ColorsEcoWatt = {
  VERT: 'VERT',
  ROUGE: 'ROUGE',
  ORANGE: 'ORANGE',
  GRIS: 'GRIS',
};
